import { FC } from 'react';

import { PublicBrandLinkV2 } from '@sparkplug/lib';

import CalloutMessage from '@components/layout/CalloutMessage';
import { SectionTitle } from '@components/layout/SectionTitle';

import BrandMappingRow, { BrandMappingRowProps } from './BrandMappingRow';

import '../shared.scss';
import './BrandMappings.scss';

interface BrandMappingsProps extends Omit<BrandMappingRowProps, 'brandLink'> {
    brandLinks: PublicBrandLinkV2[];
    accountName: string;
    isNewVendorLink?: boolean;
}

const BrandMappings: FC<BrandMappingsProps> = ({
    accountName,
    brandLinks,
    posBrandOptionsAreReady,
    posBrandOptions,
    onSave,
    accountLinkDisabled,
    isNewVendorLink,
}) => {
    const calloutMessage = (
        <div>
            <div>
                Manage the <strong>{accountName}</strong> link by mapping brands from your POS to
                each brand below.
            </div>
            {isNewVendorLink && (
                <div className="new-link-message">
                    Any brands from your POS that match the name of a brand from the associated
                    vendor have been automatically mapped. You can remove them or add non-obvious
                    matches as necessary.
                </div>
            )}
        </div>
    );

    return (
        <section className="brand-mappings">
            <CalloutMessage message={calloutMessage} />
            <SectionTitle>Brand Mappings</SectionTitle>
            <div className="brand-mappings-rows">
                {brandLinks.map((brandLink) => (
                    <BrandMappingRow
                        key={brandLink.brandId}
                        posBrandOptionsAreReady={posBrandOptionsAreReady}
                        brandLink={brandLink}
                        posBrandOptions={posBrandOptions}
                        onSave={onSave}
                        accountLinkDisabled={accountLinkDisabled}
                    />
                ))}
            </div>
        </section>
    );
};

export default BrandMappings;
